var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm-specific-document loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("csp-desktop-firm-specific-document-basedata", {
                    attrs: {
                      "form-context":
                        _vm.initialFormContexts.firmSpecificDocumentBasedata,
                      "is-creation-form": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }